import styled from 'styled-components';

export const SubsystemCompareBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SubsystemCompareBlockTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CompareSubsystemCoverage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
